import { SelectModelModel } from '../../../../select/select-model';

export const BUTTON_WIDTH_MODEL: SelectModelModel = [
  { value: 'auto', item: 'Auto' },
  { value: 'full', item: 'Full' },
] as const;

export type ButtonWidth = (typeof BUTTON_WIDTH_MODEL)[number]['value'];

export const BUTTON_SIZE_MODEL: SelectModelModel = [
  { value: 'xs', item: 'XS' },
  { value: 'sm', item: 'S' },
  { value: 'md', item: 'M' },
  { value: 'lg', item: 'L' },
] as const;

export type ButtonSize = (typeof BUTTON_SIZE_MODEL)[number]['value'];

export const BUTTON_STYLE_MODEL: SelectModelModel = [
  { value: 'rectangle', item: 'Rectángulo' },
  { value: 'rounded', item: 'Redondeado' },
  { value: 'pill', item: 'Píldora' },
] as const;

export type ButtonStyle = (typeof BUTTON_STYLE_MODEL)[number]['value'];
